// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FooterDrawer {
  position: relative;
  display: flex;
  max-height: 100vh;
  height: 0vh;
  flex-direction: column;
}
.FooterDrawer .react-resizable-handle {
  width: 100%;
  padding: 0;
  margin: 0;
  top: 0.5rem;
  left: 0;
  background: none;
  transform: none;
  -webkit-font-smoothing: antialiased;
  display: var(--fa-display, inline-block);
  font-style: normal;
  font-variant: normal;
  line-height: 1;
  text-rendering: auto;
  font-family: var(--fa-style-family, "Font Awesome 6 Free");
  font-weight: var(--fa-style, 900);
}
.FooterDrawer .react-resizable-handle:after {
  position: absolute;
  top: calc(50% - 0.65rem);
  left: calc(50% - 0.65rem);
  content: "\\f07d";
  opacity: 0.33;
  font-size: 1.4rem;
}
.FooterDrawer.show {
  height: 100vh;
}
.FooterDrawer .FooterDrawer-Header,
.FooterDrawer .FooterDrawer-Footer,
.FooterDrawer .FooterDrawer-Content {
  position: relative;
  padding: 0.5rem 1rem;
}
.FooterDrawer .FooterDrawer-Header .VirtualTable-Container,
.FooterDrawer .FooterDrawer-Header .VirtualTable,
.FooterDrawer .FooterDrawer-Footer .VirtualTable-Container,
.FooterDrawer .FooterDrawer-Footer .VirtualTable,
.FooterDrawer .FooterDrawer-Content .VirtualTable-Container,
.FooterDrawer .FooterDrawer-Content .VirtualTable {
  max-height: calc(40vh - 2.75rem) !important;
  height: calc(40vh - 2.75rem) !important;
}
.FooterDrawer .FooterDrawer-Header {
  border-width: 1px 0;
  border-style: solid;
  border-color: #ccc;
  display: flex;
  justify-content: space-between;
}
.FooterDrawer .FooterDrawer-Header .FooterDrawer-Title {
  font-weight: bold;
  flex-grow: 1;
}
.FooterDrawer .FooterDrawer-Header .FooterDrawer-Close,
.FooterDrawer .FooterDrawer-Header .FooterDrawer-Minimize {
  padding-top: 0;
  padding-bottom: 0;
  z-index: 2;
  cursor: pointer;
}
.FooterDrawer .FooterDrawer-Content {
  flex-grow: 1;
}
.FooterDrawer .FooterDrawer-Footer {
  border-width: 1px 0 0 0;
  border-style: solid;
  border-color: #ccc;
}`, "",{"version":3,"sources":["webpack://./src/components/FooterDrawer/styles.scss"],"names":[],"mappings":"AAEA;EACE,kBAAA;EACA,aAAA;EACA,iBALkB;EAMlB,WAAA;EACA,sBAAA;AADF;AAEE;EACE,WAAA;EACA,UAAA;EACA,SAAA;EACA,WAAA;EACA,OAAA;EACA,gBAAA;EACA,eAAA;EACA,mCAAA;EACA,wCAAA;EACA,kBAAA;EACA,oBAAA;EACA,cAAA;EACA,oBAAA;EACA,0DAAA;EACA,iCAAA;AAAJ;AACI;EACE,kBAAA;EACA,wBAAA;EACA,yBAAA;EACA,gBAAA;EACA,aAAA;EACA,iBAAA;AACN;AAEE;EACE,aAlCgB;AAkCpB;AAEE;;;EAGE,kBAAA;EACA,oBAAA;AAAJ;AACI;;;;;;EAEE,2CAAA;EACA,uCAAA;AAKN;AAFE;EACE,mBAAA;EACA,mBAAA;EACA,kBAAA;EACA,aAAA;EACA,8BAAA;AAIJ;AAHI;EACE,iBAAA;EACA,YAAA;AAKN;AAHI;;EAEE,cAAA;EACA,iBAAA;EACA,UAAA;EACA,eAAA;AAKN;AAFE;EACE,YAAA;AAIJ;AAFE;EACE,uBAAA;EACA,mBAAA;EACA,kBAAA;AAIJ","sourcesContent":["$max-drawer-height: 100vh;\n\n.FooterDrawer {\n  position: relative;\n  display: flex;\n  max-height: $max-drawer-height;\n  height: 0vh;\n  flex-direction: column;\n  .react-resizable-handle {\n    width: 100%;\n    padding: 0;\n    margin: 0;\n    top: 0.5rem;\n    left: 0;\n    background: none;\n    transform: none;\n    -webkit-font-smoothing: antialiased;\n    display: var(--fa-display, inline-block);\n    font-style: normal;\n    font-variant: normal;\n    line-height: 1;\n    text-rendering: auto;\n    font-family: var(--fa-style-family, 'Font Awesome 6 Free');\n    font-weight: var(--fa-style, 900);\n    &:after {\n      position: absolute;\n      top: calc(50% - 0.65rem);\n      left: calc(50% - 0.65rem);\n      content: '\\f07d';\n      opacity: 0.33;\n      font-size: 1.4rem;\n    }\n  }\n  &.show {\n    height: $max-drawer-height;\n  }\n  .FooterDrawer-Header,\n  .FooterDrawer-Footer,\n  .FooterDrawer-Content {\n    position: relative;\n    padding: 0.5rem 1rem;\n    .VirtualTable-Container,\n    .VirtualTable {\n      max-height: calc(40vh - 2.75rem) !important;\n      height: calc(40vh - 2.75rem) !important;\n    }\n  }\n  .FooterDrawer-Header {\n    border-width: 1px 0;\n    border-style: solid;\n    border-color: #ccc;\n    display: flex;\n    justify-content: space-between;\n    .FooterDrawer-Title {\n      font-weight: bold;\n      flex-grow: 1;\n    }\n    .FooterDrawer-Close,\n    .FooterDrawer-Minimize {\n      padding-top: 0;\n      padding-bottom: 0;\n      z-index: 2;\n      cursor: pointer;\n    }\n  }\n  .FooterDrawer-Content {\n    flex-grow: 1;\n  }\n  .FooterDrawer-Footer {\n    border-width: 1px 0 0 0;\n    border-style: solid;\n    border-color: #ccc;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
